<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
         <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                @change="getDataBranch(Company)"
                hide-details
                label="บริษัท"
                class="ma-2"
              ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                hide-details
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                hide-details
                label="แผนก"
                class="ma-2"
              ></v-select>
                <v-icon
                color="#871B12"
                size="30"
                @click="getData()"
                >mdi-calendar-search</v-icon
              >
              <v-icon
                color="#871B12"
                size="30"
                @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>

          <!-- ADD -->
          <v-dialog v-model="dialogEdit" persistent max-width="80%">
            <v-card>
              <v-card-title>
                <span class="headline">แก้ไขรูปพนักงาน</span>
              </v-card-title>
              {{formUpdate.empCode}}
              {{formUpdate.empFull_NameTH}}
              <v-col cols="12" class="text-center">
                        <center>
                          <v-img
                            :lazy-src="formUpdate.empImageUrl"
                            max-height="auto"
                            max-width="1000"
                            :src="formUpdate.empImageUrl"
                          ></v-img>
                        </center>

                        <br />
                        <v-file-input
                          v-model="filesEdit"
                          show-size
                          accept="image/png, image/jpeg"
                          @change="fileEditUpload"
                          placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                          :rules="imageRules"
                          outlined
                          dense
                          required
                        ></v-file-input>
                      </v-col>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="dark darken-1"
                  text
                  @click="(dialogEdit = false)"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  text
                  @click="addData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  เพิ่ม
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end add -->

         <!-- data table -->
         <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="question"
                      fab
                      small
                      @click.stop="(dialogEdit = true), getDataById(item)"
                    >
                      <v-icon dark> mdi-tools </v-icon>
                    </v-btn>
                  </template>

                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      e1: 1,
      PK: '',
      path: '/employee/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ข้อมูลพนักงานรวม',
          disabled: true,
          href: '/HRM/Employee/EmployeeManage'
        }
      ],
      // End Menu Config
      dataReady: true,
      date: new Date().toISOString().substr(0, 10),
      formUpdate: [],
      // Dialog ADD IMPORT
      dialogEdit: false,
      session: this.$session.getAll(),
      searchAll2: '',
      // Search Advanced
      filesEdit: null,
      imageRules: [
        (value) =>
          !value || value.size < 5000000 || 'size should be less than 5 MB!'
      ],
      // Data Table Config
      columns: [
        { text: 'รหัสพนักงาน', value: 'empCode', align: 'center' },
        { text: 'ชื่อ-นามสกุล', value: 'empFull_NameTH' },
        { text: 'ประเภทพนักงาน', value: 'positionTypeName' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'บริษัท', value: 'masCompanyName' },
        { text: 'วันเข้าทำงาน', value: 'startDate' },
        { text: 'อายุงาน', value: 'workDate' },
        // { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      disableBranch: true,
      disableDeparment: true
    }
  },
  async mounted () {
    await this.getGetTokenForEmployee()
    this.dataReady = false

    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
    // Get Data
    await this.getData()
  },
  methods: {
    async clear () {
      console.log('clear')
      this.Company = ''
      this.Branch = ''
      this.Department = ''
      await this.getData()
    },
    getDataById (item) {
      console.log('get date edit', item)
      this.formUpdate = item
    },
    async getData () {
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ข้อมูลใน Import

      var Company = (this.Company === '' ? '' : '&masCompanyName=' + this.Company)
      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "get?RECORD_STATUS=N" + Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
          this.dataItem.forEach((data) => {
            if (data.empImageUrl) {
              data.empImageUrl = this.DNS_IP + '/' + data.empImageUrl
            }
          })
          console.log(this.dataItem)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    async fileEditUpload () {
      const _this = this
      let params = new FormData()
      params.append('file', _this.filesEdit)
      if (_this.filesEdit.size < 5000000) {
        try {
          await axios
            .post(_this.DNS_IP_UPLOAD + '/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: this.$session.getAll().data.empCode,
                Topic: 'news'
              }
            })
            .then(function (response) {
              console.log('filesEdit', response.data)
              _this.formUpdate.empImageUrl =
                _this.DNS_IP_UPLOAD + '/' + response.data
            })
            .catch((error) => {
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
        }
        console.log('this.filesEdit', _this.filesEdit)
        console.log('this.filesEdit', _this.filesEdit.size)
      }
    },
    // บรษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    }
  }
}
</script>
<style>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeManageImage.vue